import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/system';
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next';


export const languageOptions = {
  hu: {
    icon: "/assets/flags/flag-hu.svg",
    label: "hu",
  },
  en: {
    icon: "/assets/flags/flag-gb.svg",
    label: "en",
    disabled: false,
  },
  de: {
    icon: "/assets/flags/flag-de.svg",
    label: "de",
    disabled: true,
  },
  es: {
    icon: "/assets/flags/flag-es.svg",
    label: "es",
    disabled: true,
  },
  fr: {
    icon: "/assets/flags/flag-fr.svg",
    label: "fr",
    disabled: true,
  },
};

export const LANG_STORAGE_KEY = "app.language";
const storeLanguage = (language) => {
  window.localStorage.setItem(LANG_STORAGE_KEY, language);
};

const LangaugeChip = () => {
  const { i18n, t } = useTranslation();
  const llang = window.localStorage.getItem(LANG_STORAGE_KEY);
  const label = languageOptions[llang]?.label;

  useEffect(() => { // NOTE: i am afraid this is not working, i solved the problem in the i18.js file
    i18n.changeLanguage(llang);
  }, [llang])

  console.log("language", label);
  const handleChange = useCallback(
    async (language) => {
      storeLanguage(language);
      await i18n.changeLanguage(language);
    },
    [i18n, t],
  );
  return (
    <div>
      {(Object.keys(languageOptions)).map((language) => {
        const option = languageOptions[language];
        return (
          <Box
            display={option.disabled ? "none" : "flex"}
            sx={{
              cursor: "pointer",
            }}
          >
            <Typography
              key={option.label}
              onClick={() => handleChange(option.label)}
              color={option.label === label ? "primary" : "textPrimary"}
            >
              {t(option.label)}
            </Typography>
          </Box>
        )
      })

      }
    </div>
  )
}

export default LangaugeChip